import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../tooltip";
import { Typography } from "../../../typography";

function SystemMessageComponent({ message }: { message: string }) {
  return (
    <div className="flex items-center">
      <div className="h-px w-full bg-border" />
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="px-3 shrink-0 py-1 bg-background-100 border border-border rounded-lg overflow-hidden w-fit max-w-[60%] break-all line-clamp-1">
              <Typography
                variant="detailMedium"
                className="text-muted-foreground"
              >
                {message}
              </Typography>
            </div>
          </TooltipTrigger>
          <TooltipContent side="bottom">{message}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <div className="h-px w-full bg-border" />
    </div>
  );
}

export default SystemMessageComponent;
